import { ConfigOption } from '@ngx-formly/core';
import { PaymentTermsDropDownComponent } from './payment-terms-drop-down/payment-terms-drop-down.component';

export const PAYMENT_TERMS_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-payment-term-drop-down', component: PaymentTermsDropDownComponent, wrappers: ['simple-title'] },
]
